import type { FormStateId } from '#types';
import { draftFormStateId } from './draftFormStateId';

/**
 * Eligible "close" targets for Close & Create, and `FormStateId` options under "Set form to"
 * (excludes `draftFormStateId`; that path is "New draft version" in the version group).
 */
export function isCloseAndCreateTargetState(state: FormStateId): boolean {
  return state !== draftFormStateId;
}
